import { useMutation } from '@tanstack/react-query'
import { deleteChannel } from 'services/ChannelService'

export const useDeleteChannel = () => {
  return useMutation({ mutationFn: deleteChannel })
}
